import type { EntryCheckIn } from "./queries/entries";

/** What the prezence left open on a přihláška (checkin.Problem). */
export const CHECKIN_PROBLEM_LABELS: Record<EntryCheckIn["problem"], string> = {
  nobody: "Prezence: nikdo nepřišel",
  below_minimum: "Prezence: formace bez nich nemůže startovat",
  missing: "Prezence: někdo chybí",
  late_arrival: "Prezence: přeškrtnutá, ale někdo dorazil",
};
